import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { getClaimSla, getSlaReasons, setSlaReason } from "../../services/apiClient.js";
import ReasonPickerModal from "../shared/ReasonPickerModal.jsx";

// Out-Of-Target reasons ON the Progress screen (Karen 2026-07-25 — staff read
// the reason here, so let them see/set it here, not only on the SLA report).
// Shows each SLA step this claim is out-of-target on, with its current reason,
// and sets it with the SAME picker as the SLA report. Writes the same
// claim_sla_entries the SLA report reads — one reason, two places to work it.
export default function ClaimOotReasons({ claimId }) {
  const [columns, setColumns] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [picker, setPicker] = useState(null); // { columnKey, label, current }
  const [error, setError] = useState("");

  function load() {
    getClaimSla(claimId)
      .then((d) => setColumns(d.columns))
      .catch(() => setError("Unable to load Out-Of-Target reasons."));
  }
  useEffect(() => {
    load();
    getSlaReasons().then(setReasons).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimId]);

  async function save(reasonId) {
    try {
      await setSlaReason(claimId, picker.columnKey, reasonId);
      setPicker(null);
      load();
    } catch (err) {
      setError(err.response?.data?.error || "Unable to save the reason.");
      setPicker(null);
    }
  }

  const oot = (columns || []).filter((c) => c.out_of_target);
  if (!columns || oot.length === 0) return null; // nothing out of target → no panel

  const stateClass = (c) =>
    c.state === "oot_claims_fault"
      ? "text-danger"
      : c.state === "oot_excused"
        ? "text-success"
        : "text-warning";

  return (
    <div className="mb-3 border rounded p-2">
      <div className="fw-semibold small text-uppercase text-muted mb-2" style={{ letterSpacing: "0.06em" }}>
        Out Of Target Reasons
      </div>
      <div className="d-flex flex-column gap-1">
        {oot.map((c) => (
          <div key={c.key} className="d-flex align-items-center justify-content-between gap-2 small flex-wrap">
            <span>
              {c.label} <span className="text-muted">({c.days}/{c.days_allowed} days)</span>
            </span>
            <span className="d-flex align-items-center gap-2">
              <span className={stateClass(c)}>
                {c.reason
                  ? `${c.reason}${c.claims_fault ? " (claims' fault)" : " (excused)"}`
                  : "No reason chosen"}
              </span>
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => setPicker({ columnKey: c.key, label: c.label, current: c.reason || "" })}
              >
                {c.reason ? "Change" : "Add reason"}
              </Button>
            </span>
          </div>
        ))}
      </div>
      {error ? <div className="text-danger small mt-1">{error}</div> : null}
      <ReasonPickerModal
        show={!!picker}
        title={picker ? `Out-Of-Target reason — ${picker.label}` : ""}
        reasons={reasons}
        columnKey={picker?.columnKey || null}
        current={picker?.current || ""}
        onSelect={(id) => save(id)}
        onClear={() => save(null)}
        onHide={() => setPicker(null)}
      />
    </div>
  );
}
